<template>
  <div class="pagination d-flex justify-content-between">
    <multiselect
      @select="selectProductsPerPage"
      v-model="selectedProductsPerPage"
      placeholder=""
      :options="paginationOptions"
      :searchable="false"
      :multiple="false"
      :selected-label="''"
      :select-label="''"
      :deselect-label="''"
      :allow-empty="false">
      <template slot="singleLabel" slot-scope="{ option }">{{ option }} {{ $t('products.products2') }}</template>
    </multiselect>
    <pagination v-model="currentPage" :records="productsCount" :perPage="selectedProductsPerPage" @paginate="paginateCallback"/>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'
import Multiselect from 'vue-multiselect'

export default {
  name: 'ProductsPagination',

  data () {
    return {
      currentPage: this.page,
      paginationOptions: [5, 10, 15, 20, 50],
      selectedProductsPerPage: this.productsPerPage
    }
  },

  props: {
    page: { required: true, type: Number },
    productsCount: { required: true, type: Number },
    productsPerPage: { required: true, type: Number }
  },

  methods: {
    selectProductsPerPage (value) {
      this.$emit('onProductsPerPageChange', value)
    },

    paginateCallback (value) {
      this.$emit('onPaginateCallback', value)
    }
  },

  components: { Multiselect, Pagination }
}
</script>
